<template>
    <ac-modal :title="'Create New Enrollment Link'" ref="modalRef">
        <template>
            <div v-if="widgetReady">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <div class="form-group">
                            <label>Link Name</label>
                            <small>&nbsp;&nbsp;&nbsp;&nbsp;<span class="redText">required</span></small>
                            <br />
                            <input class="form-control" type="text" name="name" v-model="vm.name"
                                placeholder="Example: Open Enrollment Link, Year-Round Enrollment Link, etc." />
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-12">
                        <div class="form-group">
                            <label>Link Description</label><br />
                            <textarea class="form-control" name="description" value="" v-model="vm.description"
                                placeholder="Example: Only give this out to new hire employees gaining coverage outside the open enrollment timeframe."></textarea>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <small class="acressaBlueText">Please note: Both the Link Name and the Link Description will only be
                            visible from your ‘Enrollment Link Management’ page. They are available to
                            serve as a means through which you and members of your team can organize and describe your
                            various links, so feel free to use whatever naming nomenclature and level of
                            detail
                            you desire.
                        </small>
                        <br />
                        <br />
                    </div>
                </div>
                <div class="row">
                    <hr />
                    <div class="col-sm-12 col-lg-4">
                        <div class="form-group">
                            <label>Benefit Effective Date</label>
                            <small>&nbsp;&nbsp;<span class="redText">required</span></small>
                            <br />
                            <ac-date-picker v-model="vm.effDate">

                            </ac-date-picker>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4">
                        <div class="form-group">
                            <label>Link Activation Date</label>
                            <small>&nbsp;&nbsp;<span class="redText">required</span></small>
                            <br />
                            <ac-date-picker v-model="vm.linkEffDate">

                            </ac-date-picker>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4">
                        <div class="form-group">
                            <label>Link Expiration Date</label>
                            <small>&nbsp;&nbsp;<span class="redText">required</span></small>
                            <br />
                            <ac-date-picker v-model="vm.linkExpDate">

                            </ac-date-picker>
                        </div>
                    </div>
                </div>
                <div class="row textBanner">
                    <hr />
                    <div class="col-xs-12 col-lg-12">
                        <div class="switch">
                            Text Banner Option
                            <label class="pull-right">
                                No<input type="checkbox" v-model="vm.customBanner">
                                <span class="lever"></span>Yes
                            </label>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <small class="acressaBlueText">
                            By enabling this option, you can create a custom text banner that will display at the top for
                            members using this link.
                        </small>
                        <br />
                        <div v-if="vm.customBanner">
                            <small class="acressaBlueText" :class="{ 'red-background': plainBannerError }">
                                Character count cannot exceed 250 characters. Character Count: {{ plainBannerLength }}
                            </small>
                            <br />
                            <textarea class="form-control" v-model="bannerText">
                        </textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <hr />
                <div class="col-xs-12 col-lg-12">
                    <div class="switch">
                        Allow Sign Ups
                        <label class="pull-right">
                            No<input type="checkbox" v-model="vm.allowSignups">
                            <span class="lever"></span>Yes
                        </label>
                    </div>
                </div>
                <div class="col-xs-12">
                    <small class="acressaBlueText">
                        By enabling this option, members using this link will have the ability to sign up and create an
                        account associated with our group.
                    </small>
                    <br />
                    <br />
                </div>
            </div>
            <div class="row">
                <hr />
                <div class="col-xs-12 col-lg-12">
                    <div class="switch">
                        Date Option
                        <label class="pull-right">
                            No<input type="checkbox" v-model="vm.dateOption">
                            <span class="lever"></span>Yes
                        </label>
                    </div>
                </div>
                <div class="col-xs-12">
                    <small class="acressaBlueText">
                        By enabling this option, members using link will have the ability to start on the sign up day or
                        schedule to start on the first of the upcoming month.
                    </small>
                    <br />
                    <br />
                </div>
            </div>
            <div class="row">
                <hr />
                <div class="col-xs-12 col-lg-12">
                    <div class="switch">
                        Allow Dependents
                        <label class="pull-right">
                            No<input type="checkbox" v-model="vm.allowDependents">
                            <span class="lever"></span>Yes
                        </label>
                    </div>
                </div>
                <div class="col-xs-12">
                    <small class="acressaBlueText">
                        By enabling this option, members using link will have the ability to add dependents to their
                        account.
                    </small>
                    <br />
                    <br />
                </div>
            </div>
            <div class="row">
                <hr />
                <div class="col-xs-12 col-lg-12">
                    <div class="switch">
                        Referral Survey
                        <label class="pull-right">
                            No<input type="checkbox" v-model="vm.referralSurvey">
                            <span class="lever"></span>Yes
                        </label>
                    </div>
                </div>
                <div class="col-xs-12">
                    <small class="acressaBlueText">
                        By enabling this option, members using link will be required to answer "How did you hear about us?".
                    </small>
                    <br />
                    <br />
                </div>
            </div>
            <div class="row">
                <hr />
                <div class="col-xs-12 col-lg-12">
                    <div class="switch">
                        Business Owner Survey
                        <label class="pull-right">
                            No<input type="checkbox" v-model="vm.businessOwnerSurvey">
                            <span class="lever"></span>Yes
                        </label>
                    </div>
                </div>
                <div class="col-xs-12">
                    <small class="acressaBlueText">
                        By enabling this option, members using link will be asked "Are you a business owner?" and, if so, whether they would like to learn more about your services for their employees.
                    </small>
                    <br />
                    <br />
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button type="button" class="btn btn-red btn-sm" :action="closeModal">
                CANCEL
            </ac-button>
            <ac-button class="btn btn-green btn-sm" role="button" :action="save">
                SAVE
            </ac-button>
        </template>
    </ac-modal>
</template>

<script>
import { api } from "../../../../global/framework/api.js";
import { notifications } from "@/global/notifications.js";

export default {
    name: "SaveLinkModal",
    data() {
        return {
            companyId: 0,
            widgetReady: false,
            vm: {
                customBannerText: "",
                customBanner: false
            },
            bannerText: '',
            plainBannerLength: 0,
            plainBannerError: false,
        }
    },
    watch: {
        bannerText(newVal) {
            let tempElement = document.createElement('div');
            tempElement.innerHTML = newVal;
            let text = tempElement.textContent || tempElement.innerText;
            this.plainBannerLength = text.length;
            this.plainBannerError = this.plainBannerLength > 250 ? true : false;
        }
    },
    methods: {
        async showModal({ companyId, linkId }) {
            this.companyId = companyId;
            await this.init(linkId);
            this.$refs.modalRef.open();
        },
        async init(linkId) {
            let data = null;
            if (linkId > 0) {
                data = await api.getDataWithTwoIds('EnrollmentLink', this.companyId, 'Get', linkId);
            } else {
                data = await api.get('EnrollmentLink', this.companyId, 'GetEnrollmentLinkTemplate');
            }
            if (data.customBannerText != null) {
                data.customBanner = true;
                this.bannerText = data.customBannerText;
            }
            //console.log(data);
            this.mapData('vm', data);
            this.widgetReady = true;
        },
        closeModal() {
            this.$refs.modalRef.close();
        },
        async save() {
            if (this.vm.customBanner == false) {
                this.bannerText = null;
                this.vm.customBannerText = null;
            }
            else if (this.vm.customBanner === true && this.bannerText != '') {
                this.vm.customBannerText = this.bannerText;
            }
            else {
                notifications.showError({ message: "Custom Banner requires content if enabled", title: "Error" });
                return;
            }
            if (this.plainBannerLength > 250) {
                notifications.showError({ message: "Custom Banner exceeds size limits.", title: "Error" });
                return;
            } else {
                let result = await api.post('EnrollmentLink/' + this.companyId, 'SaveEnrollmentLink', this.vm);
                if (result) {
                    this.$bus.$emit(this.$AcEvents.ENROLLMENT_LINK_CHANGE, result);
                    this.closeModal();
                }
            }
        }
    }
}
</script>

<style scoped>
.red-background {
    background-color: red
}
</style>